import { type LoaderFunction } from 'react-router';
import { getAppPageFromPath } from '../../helpers/urlHelper';
import { isOperationPage } from '../../types/app';
import store from '../../store';
import { getLanguages, setOperation } from '../../reducers/app/appReducer';
import { setCookieForAppView } from '../../helpers/appViewHelper';
import { viewContext } from '../middleware/context';

const loader: LoaderFunction = async (args) => {
  const { params, request, context } = args;

  const view = context.get(viewContext);

  const url = new URL(request.url);
  const operation =
    view === 'app' && url.pathname.includes('/ikeaapp/')
      ? 'ikeaapp'
      : params.operation || '';
  const page = getAppPageFromPath(url.pathname);

  if (!isOperationPage(page)) {
    return;
  }

  const currentOperation = store.getState().app.operation;
  if (currentOperation !== operation) {
    store.dispatch(setOperation(operation));
    setCookieForAppView(operation, view);
  }

  if (!store.getState().app.languages.code) {
    await store.dispatch(getLanguages(CSS_CONFIG.country));
  }
};

export default loader;
